import Footer from "../components/Footer";
import Hero from "../components/Hero";
import MainPart from "../components/MainPart";
import Navbar from "../components/Navbar";

function Implementation(){
    return(
        <>
            <Navbar/>
            <Hero
                cName="hero-content" 
                heroImg="https://static.igem.wiki/teams/4696/wiki/hhhero-fig10.jpeg"
                title="Implementation"
            />
            <div className="content-container">

                <div className="sidepanel">
                    <ul>
                        <a href="#1" className="a-sidepanel"><ul class="header">Implementation</ul></a>
                        <a href="#2" className="a-sidepanel"><ul class="subheader">The future of CAR-Ma</ul></a>
                        <a href="#3" className="a-sidepanel"><ul class="header">References</ul></a>
                    </ul>
                </div>
                <MainPart
                    section_id={1}
                    container_cName="main-paragraph-container"
                    heading='Implementation'
                    subheading_cName='hide'
                    paragraph={[
                        'Implementation of modern immunotherapies has always been a roadblock of the biological revolution in cancer therapeutics. CAR-T having much success and inspiring companies like Legend Biotech, is limited due to issues stemming from toxicity, limited persistence, and difficulty in targeting solid tumors. CAR-Ma utilizing CAR-Macrophages takes over where CAR-T fails. Several preclinical studies have shown that CAR-Macrophages can effectively eliminate cancer cells in vitro and in vivo. '
                    ]}
                    img_cName="hide"
                />
                <MainPart
                    section_id={2}
                    container_cName="main-paragraph-container"
                    heading_cName="hide"
                    subheading='The future of CAR-Ma'
                    paragraph={[
                        'CAR-Ma can be characterized into several phases ranging from our proof-of-concept to full implementation in human therapeutics. The initial work carried out by our team lays the foundation needed for a revolution in immunotherapeutics. Phase I of CAR-Ma involved the development and characterization of CAR-M in combination with a small-molecule modulated control system in vitro. This will allow us to prove that CAR-M is suitably efficient and effective against tumor cells and demonstrate that our control system can work within the specified timeframe. This will also be the goal in the months following the iGEM Giant Jamboree. '
                        ,<br/>,<br/>,
                        'In the near future, CAR-Ma will begin Phase II directly in continuity with Phase I. CAR-Ma exists in the most opportune moment for the rapid development of CAR-Ma Phase II. This phase will leverage lipid nanoparticle (LNP) packaging for the usage as an in vivo therapeutic. Similarly to the recent mRNA based vaccination technologies brought about by the COVID-19 pandemic. The CAR-Ma srRNA vectors can be easily developed, produced, scaled-up and distributed by the robust systems of scale, manufacturing and logistics developed and tested during the COVID-19 pandemic. CAR-Ma will incorporate an advanced functionalized lipid nanoparticle. This is an advanced lipid nanoparticle which incorporates antibodies to specifically and efficiently target the desired cells (Marques et al., 2023), in this case macrophages. The complete Phase II CAR-Ma system would carry both the srRNA segment encoding the CAR complex as well as a mRNA segment containing the Cas9 SIRPa knockout system allowing for a one-time injection, off-the-shelf cancer therapeutic that can be easily injected into patients then shutoff via antibiotics if the system is no longer needed. This will be  subject to future clinical trials.'
                        ,<br/>,<br/>,
                        'Phase III of CAR-Ma is expansion. CAR-Ma is modular in nature, the CAR system can be updated and enhanced for better specificity, efficiency and to broaden the range of targets. The eventual goal is to carry CAR-Ma to be able to tackle most, if not all the solid cancers currently afflicting humanity. A further branch of CAR-Ma also aims to utilize this system as the basis and foundation of therapies that can leverage the longer-term, non-integrative, shut-off capable system developed by CAR-Ma.'
                    ]}
                    img_cName="hide"
                />
                
                <MainPart
                    section_id={3}
                    container_cName="main-paragraph-container"
                    heading="References"
                    subheading_cName="hide"
                    paragraph={[
                        'Marques, A. C., Costa, P. C., Velho, S., & Amaral, M. H. (2023). Lipid Nanoparticles Functionalized with Antibodies for Anticancer Drug Therapy. Pharmaceutics, 15(1), 216. https://doi.org/10.3390/pharmaceutics15010216'
                    ]}
                    img_cName="hide"
                />
                
                
            </div>

            
            <Footer/>
        </>
    )
}

export default Implementation;